import * as React from 'react'
import { ReactNode } from 'react'
import { t } from 'ttag'
import YumButton, { YumButtonProps } from '../YumButton/YumButton'
import YumButtonGroup from '../YumButtonGroup/YumButtonGroup'
import { ButtonProps } from '@material-ui/core/Button'

interface IYumCancelButtonProps extends Omit<YumButtonProps, 'children'> {
  text?: string
  submitInProgress?: boolean
}

const YumCancelButton = ({ text, submitInProgress, ...props }: IYumCancelButtonProps) => {
  return (
    <YumButton
      disabled={submitInProgress}
      variant="outlined"
      // Keep button visual weight while disabled.
      disableDisabledOpacity={true}
      {...props}
    >
      {text || t`Cancel`}
    </YumButton>
  )
}

export default YumCancelButton
